import { Component, Input, ChangeDetectionStrategy , ViewEncapsulation , OnInit, OnChanges, SimpleChanges, AfterViewInit, Output, EventEmitter} from "@angular/core";
import { ScientificArchiveDocumentDto } from "src/app/models/scientific-archive-document-dto";
import { LABELS } from "./scientific-archive-document-details.constants";
import { ImageDto } from "src/app/models/image-dto";
import { Observable } from "rxjs";

@Component({
    selector: 'app-scientific-archive-document-details',
    templateUrl: './scientific-archive-document-details.component.html',
    styleUrls: ['./scientific-archive-document-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScientificArchiveDocumentDetailsComponent {
    @Input() details: ScientificArchiveDocumentDto | undefined;
    @Input() images: ImageDto[] | undefined;
    @Input() thumbnails: ImageDto[] | undefined;
    @Input() currentLanguage!: Observable<string>;


    @Output() viewFolder: EventEmitter<number> = new EventEmitter<number>();

    LABELS = LABELS;
    constructor() {

    }
    
    goToFolder(enttyId: number) {
        this.viewFolder.emit(enttyId);
    }



}